import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Grid, TablePagination, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import apiInstance from '../../../services/ServiceApi';

const BuscarCliente = ({ open, onClose, idLineaNegocio, onSelectClient,lineaNegocio }) => {
    const [searchResults, setSearchResults] = useState([]);
    const [searchData, setSearchData] = useState({
        identificador: '',
        numeroDocumento: '',
        telefono: '',
        search: '',
        fecha: '',
        fecha_aprobacion: '',
        rango_fecha_aprobacion: '',
    });
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const rowsPerPage = 1;

    const handleInputChange = (e) => {
        setSearchData({
            ...searchData,
            [e.target.name]: e.target.value
        });
    }

    const handleSearch = () => {
        //const { identificador, numeroDocumento, telefono, nombres, apellidos, nombreCompleto } = searchData;

        const queryParams = new URLSearchParams(searchData); // Convertir el objeto searchData en una cadena de consulta

        const searchUrl = `/buscarCliente?linea_negocio_id=${idLineaNegocio}&${queryParams}&page=${page + 1}`;
        apiInstance.get(searchUrl)
            .then(response => {
                const { results, count } = response.data;
                setSearchResults(results);
                const totalPagesCount = Math.ceil(count / rowsPerPage);
                setTotalPages(totalPagesCount);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        handleSearch();
    }, [page]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}
            >
                <Grid container spacing={2}>
                    <Grid container item xs={12} justifyContent="center">
                        <Typography variant="h6">Búsqueda de Cliente</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ maxWidth: '100%', overflow: 'auto' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <TextField size='small' fullWidth name="identificador" label="Identificador" variant="outlined" onChange={handleInputChange} />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField size='small' fullWidth name="numeroDocumento" label="Número de Documento" variant="outlined" onChange={handleInputChange} />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField size='small' fullWidth name="telefono" label="Teléfono" variant="outlined" onChange={handleInputChange} />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField size='small' fullWidth name="search" label="Buscar por nombres o apellidos" variant="outlined" onChange={handleInputChange} />
                            </Grid>
                            {lineaNegocio && lineaNegocio.id ===4 && <>
                                <Grid item xs={12} sm={3}>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <InputLabel id="Fecha Aprobación">Tipo</InputLabel>
                                    <Select
                                        labelId="Fecha Aprobación"
                                        id="demo-simple-select-outlined"
                                        value={searchData.fecha_aprobacion}
                                        onChange={handleInputChange}
                                        label="Tipo"
                                        name="fecha_aprobacion"
                                    >
                                        <MenuItem value={1}>Mes Cero</MenuItem>
                                        <MenuItem value={2}>Cosecha</MenuItem>
                                    </Select>
                                </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField size='small' fullWidth name="rango_fecha_aprobacion" label="Rango de Fechas (ej. 5,10)" variant="outlined" onChange={handleInputChange} />
                                </Grid>
                                </>
                            }
                            <Grid item xs={12}>
                                <Button variant="contained" onClick={handleSearch}>Buscar</Button>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid container item xs={12} justifyContent="center">
                    <TableContainer component={Paper} sx={{ marginTop: '1rem', maxHeight: '40vh' }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Nombre Completo</TableCell>
                                        <TableCell>Identificador</TableCell>
                                        {lineaNegocio && lineaNegocio.id ===4 && 
                                            <>
                                            <TableCell>Fecha Aprobación</TableCell>
                                            <TableCell>Dias Aprobado</TableCell>
                                            </>
                                        }
                                        <TableCell>RUC/DNI</TableCell>
                                        <TableCell>Estado</TableCell>
                                        <TableCell>Acción</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {searchResults.map((result) => (
                                        <TableRow key={result.id}>
                                            <TableCell>{result.id}</TableCell>
                                            <TableCell>  {
                                                        result.nombre_completo ? 
                                                        result.nombre_completo : 
                                                        `${result.nombre} ${result.apellido_paterno}${result.apellido_materno ? ` ${result.apellido_materno}` : ''}`
                                                        }               
                                            </TableCell>
                                            <TableCell>{result.identificador}</TableCell>
                                            {lineaNegocio && lineaNegocio.id ===4 && <>
                                            <TableCell>{result.fecha_aprobacion}</TableCell>
                                            <TableCell>{result.dias_aprobado}</TableCell>
                                            </>
                                            }
                                            <TableCell>{result.numero_documento}</TableCell>
                                            <TableCell>{result.state ? "Activo" : "Inactivo"}</TableCell>
                                            <TableCell>
                                                <Button size="small" variant="contained" onClick={() => onSelectClient(result.identificador)}>Seleccionar</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={totalPages}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    )
}

export default BuscarCliente;
